import React, { useEffect } from 'react';

import { NavigationWrapper } from '../NavigationWrapper';
import { ClientNameSection } from './ClientNameSection';
import { CostSection } from './CostSection';
import { EnvironmentOwnershipSection } from './EnvironmentOwnershipSection';
import {
  fetchSettings,
  patchSettings,
  selectSettings,
  useAppDispatch,
  useAppSelector,
} from '../../../state';

import { Loading, SectionsWrapper } from './EnvironmentSetup.styles';

export const EnvironmentSetup = () => {
  const settingsData = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      !settingsData.settings &&
      !settingsData.loading &&
      !settingsData.failed
    ) {
      dispatch(fetchSettings());
    }
  }, []);

  if (settingsData.loading) {
    return <Loading />;
  }

  if (settingsData.failed) {
    return (
      <SectionsWrapper>
        Error loading data. Please try again later.
      </SectionsWrapper>
    );
  }

  const handleSave = (state: {
    clientName?: string;
    expensesAlertLimit?: number;
  }) => {
    dispatch(
      patchSettings({
        clientName: settingsData?.settings?.clientName,
        expensesAlertLimit: settingsData?.settings?.expensesAlertLimit,
        ...state,
      })
    );
  };

  return (
    <>
      <NavigationWrapper />
      <SectionsWrapper disabled={settingsData.saving}>
        {settingsData.settings ? (
          <>
            <ClientNameSection {...settingsData.settings} onSave={handleSave} />
            <CostSection {...settingsData.settings} onSave={handleSave} />
            <EnvironmentOwnershipSection {...settingsData.settings} />
          </>
        ) : (
          <div>no data</div>
        )}
      </SectionsWrapper>
    </>
  );
};
